import {
  ExternalContentFragment,
  GetExternalContentUrlForRestaurantQuery,
  GetExternalContentUrlForRestaurantQueryVariables,
} from '@/types';
import { gql } from '@apollo/client';
import { useEffect } from 'react';
import { useUniqueErrorToast } from './use-unique-toasts';
import { useWrappedQuery } from './use-wrapped-query';

const GET_EXTERNAL_CONTENT_URL_QUERY = gql`
  query GetExternalContentUrlForRestaurant(
    $externalContentID: uuid!
    $supplierUUID: uuid!
    $restaurantUUID: uuid!
  ) {
    getExternalContentUrlForRestaurant(
      external_content_id: $externalContentID
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      url
    }
  }
`;

export const useHolisticsURL = (
  restaurantUUID: string,
  supplierUUID: string,
  selectedHolisticsLink: ExternalContentFragment | undefined,
) => {
  const showUniqueErrorToast = useUniqueErrorToast();

  const {
    data,
    loading: holisticsLinkURLLoading,
    error: holisticsLinkURLError,
  } = useWrappedQuery<
    GetExternalContentUrlForRestaurantQuery,
    GetExternalContentUrlForRestaurantQueryVariables
  >(GET_EXTERNAL_CONTENT_URL_QUERY, {
    skip: !selectedHolisticsLink?.uuid,
    variables: {
      // @ts-ignore
      externalContentID: selectedHolisticsLink?.uuid,
      restaurantUUID,
      supplierUUID,
    },
  });

  useEffect(() => {
    if (holisticsLinkURLError) {
      showUniqueErrorToast();
    }
  }, [holisticsLinkURLError, showUniqueErrorToast]);

  const selectedHolisticsLinkURL = data?.getExternalContentUrlForRestaurant.url;
  return {
    holisticsLinkURLError,
    holisticsLinkURLLoading,
    selectedHolisticsLinkURL,
  };
};
